<script setup>

defineProps({
  type: {
    type: String,
    default: 'submit'
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
    <button :type="type" class="flex items-center bg-primary hover:bg-primary-light py-3 px-6 rounded text-white ml-auto">
      <div v-if="loading" class="btn-spinner mr-2" />
      <slot />
    </button>
</template>
  